import EnumClass, { build } from '../EnumClass';
import data, { CancellationReasonId, CancellationReasonData } from './data';
import * as Translations from './translations';

export class CancellationReason extends EnumClass<CancellationReasonId, CancellationReasonData> {
  public get getName() {
    return Translations.name[this.id];
  }
}

export const {
  list: CANCELLATION_REASONS,
  getById: getCancellationReasonById,
  marshaller: CancellationReasonMarshaller,
  codec: CancellationReasonCodec,
} = build<CancellationReasonId, CancellationReasonData, CancellationReason>(
  'CancellationReasonEnum',
  data,
  CancellationReason,
);
